import React, {useState} from 'react';
import Text from "../../components/Text/Text";
import Space from "../../components/Space/Space";
import Input from "../../components/Input/Input";
import Div from "../../components/Div/Div";
import Button from "../../components/Button/Button";
import {Link} from "react-router-dom";
import axios from "axios";
import {base_url, clearAuth, saveAuthTokens} from "../../helpers/request/connect";
import {getRandomToken} from "../../helpers/users";

const Login = () => {

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    return (
        <Div column alignH={"center"}>
            <Space size={"sm"} vertical={true}/>
            <Text size={"md"} weight={"medium"} align={"center"}>Sign in</Text>
            <Space size={"xmd"} vertical={true}/>
            <Input
            label={"Email"}
            placeholder={"Email"}
            type={"email"}
            onChange={(e)=>setData(prev=>{return{...prev, email: e}})}
            />
            <Space size={"md"} vertical={true}/>
            <Input
            label={"Password"}
            placeholder={"Password"}
            type={"password"}
            onChange={(e)=>setData(prev=>{return{...prev, password: e}})}
            />
            <Space size={"md"} vertical={true}/>
            <Button loading={loading} stretch={"fixed"} title={"Sign in"} onClick={()=>{
                setLoading(true);
                axios.post(`${base_url}/auth/login-v2`, {
                    ...data,
                    token: getRandomToken(64),
                    os: "web",
                    voip_token: getRandomToken(64),
                }).then((res: any)=>{
                    const auth = res?.data?.response;
                    if(auth && auth.id && auth.access_token){
                        saveAuthTokens(auth);
                        window.location.href = "/";
                    }else{
                        clearAuth();
                        setLoading(false);
                        alert("Incorrect email or password")
                    }
                }).catch(() => {
                    clearAuth();
                    setLoading(false);
                    alert("Incorrect email or password")
                });
            }}/>
            <Space size={"md"} vertical={true}/>
            <Link to={"/register"}>
                <Text>Registration</Text>
            </Link>
            <Space size={"sm"} vertical={true}/>
            <Link to={"/register"}>
                <Text color={"grey-light"}>Reset password</Text>
            </Link>
        </Div>
    );
};

export default Login;
